import React from 'react';
import { colorGrid } from 's2s-themes';
import Select from 's2s-select';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { getIntlText } from '../js/utilities';
import useSettings from "../hooks/settings";

const NotificationContainer = styled.div`
  background-color: ${colorGrid.gray0};
  display: flex;
  flex-direction: column;
  padding: 24px 24px 0 24px;
`;

const NotificationTitle = styled.div`
  color: #001221;
  font-size: 14px;
  font-weight: 600;
  line-height: 12px;
  padding: 10px 0 15px 0;
`;

const NotificationDescription = styled.div`
  color: #4c5863;
  font-size: 14px;
  line-height: 12px;
  padding-bottom: 10px;
`;

const SettingsItemContainer = styled.div`
  font-family: Open Sans;
  margin-bottom: 12px;
  padding-bottom : 16px;
`;

const NotificationSettings = (props) => {
  const [settings, { changeSettings }] = useSettings();

  const handleChangeRingtone = (selectedItem) => {
    changeSettings({ "selectedRingTone": selectedItem.value }, props.intl);
  };

  // const handleChangeRingBack = (selectedItem) => {
  //   changeSettings({ "selectedRingBack": selectedItem.value }, props.intl);
  // };

  return (
    <NotificationContainer className="NotificationsContainer" >
      <SettingsItemContainer>
        <NotificationTitle className="notificationTitleStyles" >
          {getIntlText(props.intl, 'SETTINGS-NOTIFICATIONS-RINGTONE-TITLE', "Ring tone")}
        </NotificationTitle>
        <NotificationDescription className="notificationDescriptionStyles" >
          {getIntlText(props.intl, 'SETTINGS-NOTIFICATIONS-RINGTONE-DESCRIPTION', 'Change the ring tone used for incoming calls.')}
        </NotificationDescription>
        <Select
          menuItems={settings && settings.ringTones ? settings.ringTones : []}
          selectedItem={settings && settings.selectedRingTone}
          cbOnValueChange={handleChangeRingtone}
        />
      </SettingsItemContainer>

      {/*
        // Commented out ringback per Product Manager
      
      <NotificationTitle className="notificationTitleStyles" >
        {getIntlText(props.intl, 'SETTINGS-NOTIFICATIONS-RINGBACK-TITLE', "Ring back")}
      </NotificationTitle>
      <NotificationDescription className="notificationDescriptionStyles" >
        {getIntlText(props.intl, 'SETTINGS-NOTIFICATIONS-RINGBACK-DESCRIPTION', 'Change the ring back tone used for outgoing calls.')}
      </NotificationDescription>
      <Select
        menuItems={settings && settings.ringBacks ? settings.ringBacks : []}
        selectedItem={settings && settings.selectedRingBack}
        cbOnValueChange={handleChangeRingBack}
      /> */}
    </NotificationContainer >
  );

};

NotificationSettings.propTypes = {
  cbChangeNotifications: PropTypes.func,
  notificationsDisabled: PropTypes.bool,
  ringtones: PropTypes.array,
  intl: PropTypes.object
};

NotificationSettings.defaultProps = {
  cbChangeNotifications: (bool) => { console.log("Please define a callback function for cbChangeNotifications in the Notifications component", bool); },
  notificationsDisabled: false,
  ringtones: []
};

export default NotificationSettings;
